import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { onDoChat, onInputChat, onResetChat, postChat } from '../../features/playgroundDemoSlice';
import { isValidURL } from '../../helper/helper';
import Modal from '../../ui/modal/Modal';
import Chat from './Chat';
import ExctractedInformation from './ExctractedInformation';

const PersonalizedDemoai = ({ isWhiteLable }) => {
    const { app, chatDemo } = useSelector((state) => state);
    const dispatch = useDispatch();
    const [showAskForModal, setshowAskForModal] = useState(false);
    const state = useSelector((state) => state);

    const [modalBody, setmodalBody] = useState('');
    const [modalFooter, setmodalFooter] = useState('');
    const [modaltitle, setModalTitle] = useState('');
    const [modalLoader, setmodalLoader] = useState(false);
    const [errors, setErrors] = useState(false);
    // console.log('state', chatDemo);
    const borderImageSource = "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)); linear-gradient(101deg, #4c85b0, #70cba2)";
    // background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), linear-gradient(101deg, #4c85b0, #70cba2);
    const styles = {
        borderImageSource: borderImageSource
    };
    const handleChatInput = (e) => {
        dispatch(onInputChat(e.target.value));
    }
    const checkEnterKey = (e) => {
        if (e.keyCode === 13) {
            dochat();
        }
    }
    const resetChat = () => {
        dispatch(onResetChat());
    }

    const dochat = () => {
        if (chatDemo.chatInput === '') {
            return;
        }
        let statedata = JSON.parse(JSON.stringify(app.contextData));
        console.log(statedata);
        let error = [];
        if (!statedata.company_information.companyName || !statedata.company_information.website) {
            error.push(
                {
                    'type': 'company',
                    'message': 'Please complete the “Basic info” tab before testing.'
                }

            );
            setErrors(error)

        } else {
            const companyError = error.findIndex((errorInfo) => errorInfo.type === 'company');
            if (companyError !== -1) {
                error.splice(companyError, 1);
            }
        }

        // if (!statedata.business_categories.mainCatSelected.length) {
        //     error.push(
        //         {
        //             'type': 'business',
        //             'message': 'Please choose at least one business category.'
        //         }
        //     );
        // } else {
        //     const businessError = error.findIndex((errorInfo) => errorInfo.type === 'business');
        //     if (businessError !== -1) {
        //         error.splice(businessError, 1);
        //     }
        // }

        // if (!isValidURL(statedata.company_information.website)) {
        //     error.push(
        //         {
        //             'type': 'webiste',
        //             'message': 'Please provide valid webiste url.'
        //         }
        //     );
        // } else {
        //     const webisteError = error.findIndex((errorInfo) => errorInfo.type === 'webiste');
        //     if (webisteError !== -1) {
        //         error.splice(webisteError, 1);
        //     }
        // }
        if (error.length) {
            setshowAskForModal(true);
            setModalTitle('');
            setmodalBody(errorSaveBody(error));
            setmodalFooter(errorSaveFooter());
            return;
        }
        dispatch(onDoChat());
        // if(chatDemo.chatStatus){
        const args = {
            'about_us': JSON.stringify(app.contextData.about_us),
            'additonal_faq_context': app.contextData.additonal_faq_context,
            'business_categories': JSON.stringify(app.contextData.business_categories),
            'company_information': JSON.stringify(app.contextData.company_information),
            'conversation_goal': app.contextData.conversation_goal,
            'your_faq': JSON.stringify(app.contextData.your_faq),
            'zipcoderules': JSON.stringify(app.contextData.zipcoderules),
            'question_answer': JSON.stringify(chatDemo.chat),
            'message': chatDemo.chatInput
        }
        dispatch(postChat(args));
        // }

    }
    const closeModal = () => {
        setshowAskForModal(false);
        setmodalBody('');
        setmodalFooter('');
        setModalTitle('');
    }

    const errorSaveBody = (error) => {
        return (

            <div className='text-center'>
                {error.map((err, mapindexerror) => (
                    <p style={{ color: '#343a40' }} key={mapindexerror.toString()} className='fw-bold text-center'>{err.message}</p>
                ))}
            </div>
        )
    }
    const errorSaveFooter = () => {
        return (
            <button
                type="button"
                className="yr-cancelbtn"
                data-dismiss="modal"
                onClick={closeModal}
                style={{
                    border: '2px solid #0603B8',
                    borderRadius: '0.375rem'
                }}
            >
                <span>Close</span>
            </button>
        )
    }
    return (
        <section className="checkout-demo py-5">
            <div className="container">
                <h2 className="fw-bold text-center fs-1 mb-5 text-dark">Check Out Your Personalized Demo Below</h2>
                <div className="row">
                    <div className="col-lg-7">
                        <div className="chat-box-bg bg-grey rounded-4 position-relative">
                            <div className='scrollBar_content p-xl-5 p-md-4 p-3' id='chatbody_scroll'>
                                {chatDemo.chat && chatDemo.chat.map((chat, i) => (
                                    <Chat key={i.toString()} chat={chat} />
                                ))}
                                {chatDemo.loading &&
                                    <div className='' style={{ display: 'flex', padding: 14 }}>
                                        <div class="spinner-grow" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                        <div class="spinner-grow" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                        <div class="spinner-grow" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                        {/* <img src={`${process.env.PUBLIC_URL}/images/loader_new1.gif`} alt="send" className="" style={{ width: 50 }} /> */}
                                    </div>
                                }
                            </div>

                            <div className="chat_btn-message d-md-flex d-block justify-content-between align-items-center">
                                <div className="me-3">
                                    {/* <button className='yr-cancelbtn' onClick={resetChat}>
                                        <span>Reset Chat</span>
                                    </button> */}
                                    {isWhiteLable ?
                                        <div class="button_whitelabel me-3" onClick={resetChat}>
                                            <button className='desktop_reste'>  <span>Reset Chat</span></button>
                                            <i className="fas fa-undo fa-sm mobile_reset"></i>
                                        </div>
                                        :

                                        <div class="button_stockai me-3" onClick={resetChat}>
                                            <button className='desktop_reste'>  <span>Reset Chat</span></button>
                                            <i className="fas fa-undo fa-sm mobile_reset"></i>
                                        </div>
                                    }
                                </div>
                                <div className="input_chats w-100">
                                    <div className="input-group">
                                        <textarea
                                            className='form-control pb-chat-textarea textarea-chat-extra'
                                            onChange={handleChatInput}
                                            value={chatDemo.chatInput}
                                            onKeyUp={checkEnterKey}
                                        ></textarea>
                                        {/* <input
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            aria-describedby="button-addon2"
                                            onChange={handleChatInput}
                                            value={chatDemo.chatInput}
                                            // disabled={!chatDemo.chatStatus}
                                            onKeyUp={checkEnterKey}
                                        /> */}
                                        {/* background-color: #0603b8;
    border-color: #10707f */}
                                        <div className="input-group-append">
                                            {/* <button onClick={dochat} className="btn btn-info main_btns chat_btns text-white fs-3" type="button" id="button-addon2" */}
                                            <button onClick={dochat} className="main_btns chat_btns text-white fs-3" type="button" id="button-addon2"
                                                style={isWhiteLable ? {
                                                    backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                                                    color: state.app.contextData?.buttonTextColor
                                                } : null}
                                            // style={isWhiteLable && { backgroundImage: 'linear-gradient(45deg,' + state.app.contextData?.primaryColor + ',' + state.app.contextData?.secondaryColor + ')', color: state.app.contextData?.buttonTextColor }}

                                            >
                                                <img src={`${process.env.PUBLIC_URL}/images/sendChat-white.png`} alt="send" className="img-fluid" />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="reset_btn">
                                        <button onClick={resetChat}><i className="fas fa-undo fa-sm"></i></button>
                                        <div className="mobile_chat_btn">
                                            <button onClick={dochat} className="btn btn-info main_btn chat_btn text-white fs-3" type="button" id="button-addon2">
                                                <img src={`${process.env.PUBLIC_URL}/images/sendChat-white.png`} alt="send" className="img-fluid" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-5 mt-lg-0 mt-4 text-center interested_int">
                        <h3 className="fs-5 fw-bold mb-4">Interested in integrations?</h3>
                        <ExctractedInformation />
                        <h3 className="fs-5 mb-4 mt-lg-0 mt-3">Example Integrations</h3>
                        <div className="logo_list_img">
                            <div className="logo_list">
                                <img src={`${process.env.PUBLIC_URL}/images/logo_img1.jpg`} alt="logo" className="img-fluid" />
                            </div>
                            <div className="logo_list">
                                <img src={`${process.env.PUBLIC_URL}/images/logo_img2.jpg`} alt="logo" className="img-fluid" />
                            </div>
                            <div className="logo_list">
                                <img src={`${process.env.PUBLIC_URL}/images/logo_img3.jpg`} alt="logo" className="img-fluid" />
                            </div>
                            <div className="logo_list">
                                <img src={`${process.env.PUBLIC_URL}/images/logo_img4.jpg`} alt="logo" className="img-fluid" />
                            </div>
                            <div className="logo_list">
                                <img src={`${process.env.PUBLIC_URL}/images/logo_img5.jpg`} alt="logo" className="img-fluid" />
                            </div>
                            <div className="logo_list">
                                <img src={`${process.env.PUBLIC_URL}/images/logo_img6.jpg`} alt="logo" className="img-fluid" />
                            </div>
                        </div>
                        <p className="fw-bold mt-2 mb-3">And so much more...</p>
                        <a href="https://zapier.com/apps/zyratalk/integrations" className="main_btns integrate_btn text-decoration-none mt-4"
                            style={isWhiteLable ? {
                                backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                                color: state.app.contextData?.buttonTextColor
                            } : null}
                        // style={isWhiteLable && { backgroundImage: 'linear-gradient(45deg,' + state.app.contextData?.primaryColor + ',' + state.app.contextData?.secondaryColor + ')', color: state.app.contextData?.buttonTextColor }}

                        >Integrate using <img src={`${process.env.PUBLIC_URL}/images/zapier-logo.png`} style={{ maxHeight: 28 }} alt="zapier-logo" className="img-fluid" />
                        </a>
                    </div>
                </div>
            </div>
            <Modal
                show={showAskForModal}
                modalFooter={modalFooter}
                modalBody={modalBody}
                title={modaltitle}
                closeModal={closeModal}
                modalLoader={modalLoader}
                errors={errors}
            />
        </section>

    )
}

export default PersonalizedDemoai